// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__AcWGP","social_list":"Footer_social_list__dKbUn","copy":"Footer_copy__7FwAJ","credits":"Footer_credits__oM2Rf"};